const INSERT_POLL_MODAL_ID = "POLL.insert";
const POLL_SETTINGS_MODAL_ID = "POLL.settings";
const POLL_SETTINGS_DESIGN_MODAL_ID = "POLL.design";
const POLL_LAYOUT_DROPDOWN_MODAL_ID = "POLL.layoutDropdown";
const SETTINGS_TAB = {
  layout: "layout",
  design: "design",
  settings: "settings"
};
export {
  INSERT_POLL_MODAL_ID,
  POLL_LAYOUT_DROPDOWN_MODAL_ID,
  POLL_SETTINGS_DESIGN_MODAL_ID,
  POLL_SETTINGS_MODAL_ID,
  SETTINGS_TAB
};
//# sourceMappingURL=consts.js.map
